import InsightIndex from "../../pages/private/insight/InsightIndex";
import TerminalDetailsInsight from "../../pages/private/insight/TerminalDetailsInsight";
import OverviewIndex from "../../pages/private/overview/OverviewIndex";
import CacVerificationIndex from "../../pages/private/settings/CacVerificationIndex";
import SettingsBusinessInformationIndex from "../../pages/private/settings/SettingsBusinessInformationIndex";

import SettlementAccountIndex from "../../pages/private/settings/SettlementAccountIndex";
import ListViewTerminals from "../../pages/private/terminals/AllPhysicalTerminalsIndex";
import PhysicalTerminalsDisplay from "../../pages/private/terminals/PhysicalTerminalsIndex";
import RequestTerminal from "../../pages/private/terminals/RequestTerminal";
import RequestTerminalOutputIndex from "../../pages/private/terminals/RequestTerminalOutputIndex";

import ShowRequestVirtualTerminalDetails from "../../pages/private/terminals/terminalModals/ShowRequestVirtualTerminalDetailsIndex";
import ViewRequestedTerminal from "../../pages/private/terminals/terminalModals/ViewRequestedTerminal";
import VirtualTerminalsListView from "../../pages/private/terminals/terminalModals/VirtualTerminalListIndex";
import VirtualTerminalGridView from "../../pages/private/terminals/terminalModals/VitualTerminalGridViewIndex";

import TransactionIndex from "../../pages/private/transaction/TransactionIndex";
import { RouteLinks } from "../RouteLinks";

export const private_routes_group = [
  {
    path: RouteLinks?.Overview,
    element: OverviewIndex,
  },
  {
    path: RouteLinks?.Transactions,
    element: TransactionIndex,
  },
  {
    path: RouteLinks?.Terminals,
    element: PhysicalTerminalsDisplay,
  },
  {
    path: RouteLinks?.Insights,
    element: InsightIndex,
  },
  {
    path: RouteLinks?.Terminal_details,
    element: TerminalDetailsInsight,
  },
  {
    path: RouteLinks?.Terminal_request_details,
    element: RequestTerminalOutputIndex,
  },

  // {
  //   path: RouteLinks?.Settings,
  //   element: SettingsIndex,
  // },
  {
    path: RouteLinks?.Settings_business_profile,
    element: SettingsBusinessInformationIndex,
  },
  {
    path: RouteLinks?.Settings_cac_verification,
    element: CacVerificationIndex,
  },
  {
    path: RouteLinks?.Settings_settlement_account,
    element: SettlementAccountIndex,
  },
  {
    path: RouteLinks?.Request_Terminal,
    element: RequestTerminal,
  },
  {
    path: RouteLinks?.Terminals_Virtual,
    element: VirtualTerminalGridView,
  },
  {
    path: RouteLinks?.Request_Virtual_Terminal_display,
    element: ShowRequestVirtualTerminalDetails,
  },
  {
    path: RouteLinks?.Terminal_Virtual_List,
    element: VirtualTerminalsListView,
  },

  {
    path: RouteLinks?.AllRequested_Terminal,
    element: ViewRequestedTerminal,
  },
  {
    path: RouteLinks?.Physical_Terminal_list,
    element: PhysicalTerminalsDisplay,
  },
];
